module.exports = __webpack_public_path__ + "img/public/SiteIcons/map_Pin.svg?fa064eb5";